<template>
    <div class="sa-tab-scroll">
        <b-card class="sa-card" header="Data Evento" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">{{ getLabelTraduora("patient.cardiology.lblEventDate") }}</label>
                    <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" v-model="jsonData.dataEvento" type="datetime" disabled></date-picker>
                </b-col>
            </b-row>
        </b-card>

        <b-card class="sa-card" header="Diagnosi e Trattamenti" header-tag="header" footer-tag="footer" title="">
            <div v-for="(item, index) in jsonData.listaPrestazioni" :key="index" class="p-3 mb-4 border rounded bg-light">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="mb-0 text-primary">Prestazione #{{ index + 1 }}</h5>
                    <b-button v-if="jsonData.listaPrestazioni.length > 1" variant="outline-danger" size="sm" @click="rimuoviPrestazione(index)"> Rimuovi </b-button>
                </div>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Categoria Diagnosi</label>
                        <b-form-select v-model="item.categoriaDiagnosi" :options="categoriaDiagnosiOptions" value-field="categoria" text-field="descrizione" @change="onChangeCategoriaDiagnosi($event, index)"></b-form-select>
                    </b-col>

                    <!-- CAMPO DIAGNOSI COMPATIBILE TABLET -->
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Diagnosi</label>
                        <div class="position-relative">
                            <b-form-input v-model="item.diagnosi" placeholder="Digita per cercare una diagnosi..." @input="item.showDiagnosiDropdown = true" @focus="item.showDiagnosiDropdown = true" @blur="hideDropdown(item, 'showDiagnosiDropdown')" :disabled="disabledDiagnosi"> </b-form-input>

                            <b-list-group v-if="item.showDiagnosiDropdown && getFilteredDiagnosi(item.diagnosi).length > 0" class="position-absolute w-100 shadow" style="z-index: 1050; max-height: 200px; overflow-y: auto">
                                <b-list-group-item button v-for="option in getFilteredDiagnosi(item.diagnosi)" :key="option.value" @mousedown.prevent="selezionaDiagnosi(option, index)">
                                    {{ option.text }}
                                </b-list-group-item>
                            </b-list-group>
                        </div>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="mt-2">
                        <label class="sa-label-data">Altro (Diagnosi)</label>
                        <vue-editor class="sa-qeditor" :editor-toolbar="customToolbar" v-model="item.diagnosiAltro" style="height: 200px; margin-bottom: 50px" :disabled="item.diagnosi !== 'ALTRO'" />
                    </b-col>
                </b-row>

                <hr />

                <b-row>
                    <!-- CAMPO TRATTAMENTO COMPATIBILE TABLET -->
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Trattamento</label>
                        <div class="position-relative">
                            <b-form-input v-model="item.prestazione" placeholder="Digita per cercare un trattamento..." @input="item.showTrattamentoDropdown = true" @focus="item.showTrattamentoDropdown = true" @blur="hideDropdown(item, 'showTrattamentoDropdown')"> </b-form-input>

                            <b-list-group v-if="item.showTrattamentoDropdown && getFilteredPrestazioni(item.prestazione).length > 0" class="position-absolute w-100 shadow" style="z-index: 1050; max-height: 200px; overflow-y: auto">
                                <b-list-group-item button v-for="option in getFilteredPrestazioni(item.prestazione)" :key="option.idTrattamento" @mousedown.prevent="selezionaTrattamento(option, index)">
                                    {{ option.nomeTrattamento }}
                                </b-list-group-item>
                            </b-list-group>
                        </div>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Prezzo</label>
                        <b-form-input v-model="item.prezzoPrestazione" disabled type="number"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="mt-2">
                        <label class="sa-label-data">Fiala Aggiuntiva</label>
                        <b-form-select v-model="item.fiala" :options="fialeOptions" value-field="id" text-field="name" @change="onChangeFiala($event, index)"></b-form-select>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="mt-2">
                        <label class="sa-label-data">Quantità</label>
                        <b-form-input v-model="item.fialaQuantita" type="number"></b-form-input>
                    </b-col>
                </b-row>
            </div>

            <div class="mt-3">
                <b-button variant="primary" @click="aggiungiPrestazione"> + Aggiungi Diagnosi/Trattamento </b-button>
            </div>
        </b-card>

        <b-card class="sa-card" header="Refertazione" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <eventi-dizionari-component :tipoEvento="tipoEvento" :gruppo="gruppo" tipoDizionario="CONCLUSIONI" @update="onUpdateConclusioni"></eventi-dizionari-component>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <vue-editor class="sa-qeditor" :editor-toolbar="customToolbar" v-model="jsonData.note" style="height: 250px" />
                </b-col>
            </b-row>
        </b-card>

        <b-modal ref="mdlErroreConsenso" id="mdlErroreConsenso" size="md" style="height: 100%" ok-only @ok="onClickOk" ok-title="Chiudi" variant="danger" centered title="Attenzione">
            <div class="sa-modal-error">
                <div class="sa-modal-error-message">
                    <span class="sa-timeline-date">{{ message }}</span>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import EventiDizionariComponent from "../../../base/components/EventiDizionariComponent.vue";

export default {
    components: { DatePicker, EventiDizionariComponent },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
    },
    mixins: [UtilityMixin],
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
        jsonData: {
            type: Object,
            default: function () {
                return {
                    note: "",
                    dataEvento: new Date().getTime(),
                    listaPrestazioni: [],
                };
            },
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        let sessionStorage = window.sessionStorage;
        let idPrenotazione = sessionStorage.getItem("idPrenotazione");
        me.jsonData.idAccettazione = this.$route.query.idAccettazione;
        me.jsonData.idPrenotazione = idPrenotazione;
        me.jsonData.dataEvento = new Date().getTime();

        if (!me.jsonData.listaPrestazioni || me.jsonData.listaPrestazioni.length === 0) {
            me.jsonData.listaPrestazioni = [me.getEmptyPrestazione()];
        } else {
            me.jsonData.listaPrestazioni.forEach((item) => {
                me.$set(item, "showDiagnosiDropdown", false);
                me.$set(item, "showTrattamentoDropdown", false);
            });
        }

        me.checkPresenzaConsensi();
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
        currentPage() {
            let me = this;
            me.loadDatiPacs();
        },
    },
    data() {
        return {
            rows: 0,
            currentPage: 1,
            perPage: 10,
            pathResource: "/visitabotox",
            pathResourceProdotti: "/externalbotox/prodotti",
            pathResourceConsensi: "/pazienticonsensi/check",
            pathResourcePrestazioni: "/externalprenotazioni/trattamenti",
            pathResourceCategorieDiagnosi: "/botoxdiagnosicategorie",
            pathResourceDiagnosi: "/botoxdiagnosi",
            pathResourceMaterialiTeamsystem: "/botoxdiagnosi",
            tipoEvento: "VISITA BOTOX",
            gruppo: "BOTOX",
            message: "Non si può procedere con la refertazione. Compilare prima i consensi.",
            isDisalble: false,
            linkPacs: "",
            id: "-1",
            pathResourcePazienteEventi: "/pazienteeventi/lastevent",
            idRisorsa: null,
            fialeOptions: [],
            disabledDiagnosi: false,
            diagnosiOptions: [],
            diagnosiList: [],
            categoriaDiagnosiOptions: [],
            disableCampi: false,
            listaRichieste: [],
            prestazioniOptions: [],
            customToolbar: [
                ["bold", "italic", "underline", "strike"],
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{ color: [] }, { background: [] }],
            ],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Data Ora",
                    key: "dataOraResponse",
                    formatter: function (value) {
                        return moment(new Date(value)).format("DD-MM-YYYY HH:mm");
                    },
                },
                { class: "sa-table-column-action-single", key: "actions", label: "", thStyle: "width: 8rem" },
            ],
        };
    },
    methods: {
        getEmptyPrestazione() {
            return {
                categoriaDiagnosi: "",
                diagnosi: "",
                diagnosiAltro: "",
                tipoTrattamento: "",
                prestazione: "",
                prezzoPrestazione: 0,
                prestazioneFattura: "",
                fiala: "",
                fialaDescrizione: "",
                fialaQuantita: 0,
                fialaPrezzo: 0,
                showDiagnosiDropdown: false,
                showTrattamentoDropdown: false,
            };
        },
        loadData() {
            let me = this;
            this.$emit("beforeLoadData");
            if (me.id === "-1") {
                let json = this.jsonData;
                if (!json.listaPrestazioni || json.listaPrestazioni.length === 0) {
                    json.listaPrestazioni = [this.getEmptyPrestazione()];
                } else {
                    json.listaPrestazioni.forEach((item) => {
                        this.$set(item, "showDiagnosiDropdown", false);
                        this.$set(item, "showTrattamentoDropdown", false);
                    });
                }
                this.$emit("update", json);
                this.$emit("afterLoadData");
            } else {
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
                axios.get(link).then((response) => {
                    let responseData = response.data.data;
                    if (!responseData.listaPrestazioni || responseData.listaPrestazioni.length === 0) {
                        responseData.listaPrestazioni = [this.getEmptyPrestazione()];
                    } else {
                        responseData.listaPrestazioni.forEach((item) => {
                            this.$set(item, "showDiagnosiDropdown", false);
                            this.$set(item, "showTrattamentoDropdown", false);
                        });
                    }
                    this.$emit("update", responseData);

                    if (responseData.listaPrestazioni[0] && responseData.listaPrestazioni[0].categoriaDiagnosi) {
                        me.onChangeCategoriaDiagnosi(responseData.listaPrestazioni[0].categoriaDiagnosi, 0);
                    }

                    this.$emit("afterLoadData");
                });
            }
        },
        loadPrestazioni() {
            let me = this;
            this.loadDataResources(me.pathResourcePrestazioni, null, me.loadPrestazioniSuccess, me.loadPrestazioniError);
        },
        loadPrestazioniSuccess(response) {
            let me = this;
            me.prestazioniOptions = response.data.data;
            me.prestazioniOptions.unshift();
        },
        loadPrestazioniError() {},
        onUpdateBase64() {},
        onUpdateLista(data) {
            let me = this;
            me.listaRichieste = data;
            if (me.listaRichieste.length > 0) {
                me.disableCampi = true;
                if (me.listaRichieste[0].statoAttuale !== "IN VISITA") {
                    me.disableCampi = false;
                }
            }
        },
        onVisualizza(id) {
            let me = this;
            me.isDisalble = false;
            let link = process.env.VUE_APP_PATH_API + me.pathPacsEndpoint + id;
            axios
                .get(link)
                .then((response) => {
                    me.linkPacs = "";
                    me.linkPacs = response.data.data.url;
                })
                .catch((error) => {
                    this.$emit("afterLoadData");
                    this.$bvModal
                        .msgBoxOk(error.response.data.messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then((value) => {
                            console.log(value);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
        onClose() {
            let me = this;
            me.linkPacs = "";
        },
        onUpdateConclusioni(data) {
            let me = this;
            me.jsonData.note = data;
            this.$emit("update", me.jsonData);
        },
        loadCategorieDiagnosi() {
            let me = this;
            this.loadDataResources(me.pathResourceCategorieDiagnosi, null, me.loadCategorieDiagnosiSuccess, me.loadCategorieDiagnosiError);
        },
        loadCategorieDiagnosiSuccess(response) {
            let me = this;
            me.categoriaDiagnosiOptions = response.data.data.list;
            me.categoriaDiagnosiOptions.unshift();
        },
        loadCategorieDiagnosiError() {},

        onChangeCategoriaDiagnosi(valore, index) {
            let me = this;
            let categoriaSelezionata = valore && typeof valore === "object" && valore.target ? valore.target.value : valore;

            if (index !== undefined && index !== null) {
                me.jsonData.listaPrestazioni[index].diagnosi = "";
                me.jsonData.listaPrestazioni[index].tipoTrattamento = "";
            }

            let filtro = { codiceCategoria: categoriaSelezionata };
            this.loadDataResources(me.pathResourceDiagnosi, filtro, me.loadDiagnosiSuccess, me.loadDiagnosiError);
        },
        loadDiagnosiSuccess(response) {
            let me = this;
            me.diagnosiOptions = [];
            me.diagnosiList = response.data.data.list;
            me.diagnosiList.forEach((element) => {
                me.diagnosiOptions.push({ value: element.diagnosi, text: element.diagnosi + " (" + element.tipoTrattamento + ")" });
            });
            me.disabledDiagnosi = false;
        },
        loadDiagnosiError() {},

        hideDropdown(item, field) {
            // Un piccolo timeout evita che la tendina si chiuda prima del click effettivo
            setTimeout(() => {
                item[field] = false;
            }, 200);
        },

        getFilteredDiagnosi(search) {
            if (!search) return this.diagnosiOptions;
            const lowerSearch = search.toLowerCase();
            return this.diagnosiOptions.filter((o) => o.text.toLowerCase().includes(lowerSearch));
        },

        getFilteredPrestazioni(search) {
            if (!search) return this.prestazioniOptions;
            const lowerSearch = search.toLowerCase();
            return this.prestazioniOptions.filter((o) => o.nomeTrattamento.toLowerCase().includes(lowerSearch));
        },

        selezionaDiagnosi(option, index) {
            let item = this.jsonData.listaPrestazioni[index];
            item.diagnosi = option.value;

            let diagInfo = this.diagnosiList.find((d) => d.codiceCategoria === item.categoriaDiagnosi && d.diagnosi === item.diagnosi);
            if (diagInfo) {
                item.tipoTrattamento = diagInfo.tipoTrattamento;
            }
            item.showDiagnosiDropdown = false;
        },

        selezionaTrattamento(option, index) {
            let item = this.jsonData.listaPrestazioni[index];
            item.prestazione = option.nomeTrattamento;
            item.prezzoPrestazione = option.prezzo;
            item.prestazioneFattura = option.descrizioneFattura;
            item.idPrestazione = option.idTrattamento;
            item.showTrattamentoDropdown = false;
        },

        onChangeFiala(idFiala, index) {
            let me = this;
            let item = me.jsonData.listaPrestazioni[index];
            const matchedOption = me.fialeOptions.find((element) => element.id === idFiala);

            if (matchedOption) {
                item.fialaDescrizione = matchedOption.name;
                item.fialaPrezzo = matchedOption.current_cost;
            } else {
                item.fialaDescrizione = "";
                item.fialaPrezzo = 0;
            }
        },

        aggiungiPrestazione() {
            let me = this;
            me.jsonData.listaPrestazioni.push(me.getEmptyPrestazione());
            this.$emit("update", me.jsonData);
        },
        rimuoviPrestazione(index) {
            let me = this;
            me.jsonData.listaPrestazioni.splice(index, 1);
            this.$emit("update", me.jsonData);
        },

        checkPresenzaConsensi() {
            let me = this;
            if (me.id === "-1") {
                let link = process.env.VUE_APP_PATH_API + me.pathResourceConsensi + "?idPaziente=" + me.idPaziente;
                axios
                    .get(link)
                    .then((response) => {
                        if (response.data.data.list.length > 0) {
                            me.checkPresenzaAnamnesi();
                        } else {
                            me.$refs.mdlErroreConsenso.show();
                        }
                    })
                    .catch((error) => {
                        error;
                        me.$refs.mdlErroreConsenso.show();
                    });
            } else {
                me.loadDataAnamnesiSuccess();
            }
        },
        checkPresenzaAnamnesi() {
            let me = this;
            let filtro = { idPaziente: me.idPaziente, gruppo: "BOTOX", tipoEvento: "ANAMNESI BOTOX" };
            this.loadDataResources(this.pathResourcePazienteEventi, filtro, this.loadDataAnamnesiSuccess, this.loadDataAnamnesiError);
        },
        loadDataAnamnesiSuccess(response) {
            response;
            let me = this;
            me.loadPrestazioni();
            me.loadCategorieDiagnosi();
            me.loadFiale();
            me.loadData();
        },
        loadDataAnamnesiError(error) {
            error;
            this.$router.push("/paziente/botox/anamnesi/edit/-1?idPaziente=" + this.jsonData.id);
        },
        onClickOk() {
            this.$router.push("/paziente/consensi?idPaziente=" + this.idPaziente);
        },
        loadFiale() {
            let filtro = { categoria: "Iniettabili", idAmbulatorio: sessionStorage.getItem("idAmbulatorio") };
            this.loadDataResources(this.pathResourceProdotti, filtro, this.loadFialeSuccess, this.loadFialeError);
        },
        loadFialeSuccess(response) {
            response;
            let me = this;
            me.fialeOptions = response.data.data;
            me.fialeOptions.unshift({ id: null, name: "-Seleziona Valore-" });
        },
        loadFialeError(error) {
            error;
        },
    },
};
</script>

<style></style>
